import Image from "next/image"
import Link from "next/link"
import React, {Dispatch, SetStateAction, useContext, useState} from "react"
import WhatsAppButton from "./WhatsAppButton"
import Search from "../reusable/Search"
import Typography from "../reusable/Typography/Typography"
import {useRouter} from "next/router"
import {filterUrl} from "../filter/FilterUrl"
import urlParams from "../../utility/UrlParams"
import {useTranslation} from "next-i18next"
import ListQuantityIndicator from "../reusable/ListQuantityIndicator"
import DataContext from "../../context/DataContext"
import EbikesMenu from "./mobile/EbikesMenu"
import {CollectionName} from "../../constants"

function BrandWorldMegaMenu({setIsMenuVisible}:{setIsMenuVisible:Dispatch<SetStateAction<boolean>>}) {
	const router = useRouter()
	const {t} = useTranslation()
	const {comparisonProducts} = useContext(DataContext)
	const saleTitleSelection = "Sale"
	const [isEbikesMenuVisible, setIsEbikesMenuVisible] = useState(false)
	const [activeCategory, setActiveCategory] = useState(null)
	const handleMenuItemClick = item => {
		setActiveCategory(item)
		setIsEbikesMenuVisible(prev => !prev)
	}

	const {brandWorld} = useContext(DataContext)
	return (
		<div onClick={e => {
			e.stopPropagation()
		}}
		style={{backgroundColor: "#212529", inset: "0", minHeight: "100dvh"}}
		className="d-flex container flex-column align-items-start gap-3 justify-content-start ">
			{(activeCategory?.categorySlug !== "s_pedelec" && activeCategory?.categorySlug !== "sale") &&
				<EbikesMenu isEbikesMenuVisible={isEbikesMenuVisible}
					setIsEbikesMenuVisible={setIsEbikesMenuVisible}
					setIsMenuVisible={e => setIsMenuVisible(e)}
					activeCategory={activeCategory}
				/>}
			<Search isBrandsPage
				isMegaMenu
				hideAi
				hideNavIcon />
			<WhatsAppButton
				bgColor={"#3936C2"} />

			<div style={{backgroundColor: "#212529"}}
				className="border-bottom col-12 pb-4">
				{brandWorld.brandCategories.map((item, i) =>
					item.categorySlug === "s_pedelec" || item.categorySlug === "sale" ?
						<Link href={item.categorySlug === "s_pedelec" ?
							`${filterUrl({[urlParams.categories]: "s_pedelec"}, urlParams.categories, "s_pedelec", CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing`							:
							`${filterUrl({[urlParams.categories]: "_sale", [urlParams.sortOrder]: "sale"}, urlParams.categories, "s_pedelec", CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing`}
						key={item.categorySlug}>
							<div
								className={"d-flex gap-2 align-items-center px-2 cursor-pointer rounded-2"}>
								<div className="d-flex align-items-center py-2">
									<Typography variant="bodyLgBold"
										semanticTag="span"
										style={{lineHeight: "normal", color: "#fff"}}>
										{item.categorySlug === "sale" ? t(saleTitleSelection) : t(item.title)}
									</Typography>
								</div>
								{item.categorySlug === "sale" && <Image src="/assets/icons/fire.svg"
									height={20}
									width={20}/>}
							</div>
						</Link> :
						<div key={i}
							className="d-flex justify-content-between align-items-center
                    px-2 cursor-pointer  rounded-2"
							onClick={() => handleMenuItemClick(item)}>
							<div className="d-flex align-items-center py-2">
								<Typography variant="bodyLgBold"
									semanticTag="span"
									style={{color: "#fff"}}>
									{t(item.title)}
								</Typography>
							</div>
							<Image	src={"/assets/icons/chevron-right-white.svg"}
								width={20}
								height={20}
								alt="chevron right"/>
						</div>
				)}
			</div>

			<Link href={t("/comparison-page")}>
				<div
					className="d-flex col-12  justify-content-between align-items-center cursor-pointer">
					<div className="d-flex justify-content-start py-2 align-items-center">
						<Image	src={"/assets/icons/comparison-white.svg"}
							width={20}
							height={20}
							alt="Resources"/>
						<Typography variant="bodyLg"
							style={{color: "#FFFFFF"}}
							semanticTag="span"
							className="ms-3">{t("comparison-list")}</Typography>
					</div>
					<div className="d-flex align-items-center gap-1">
						<ListQuantityIndicator listLength={comparisonProducts.length}
							isAbsolute={false}/>
						<Image	src={"/assets/icons/chevron-right-white.svg"}
							width={20}
							height={20}
							alt="chevron right"/>
					</div>
				</div>
			</Link>
		</div>
	)
}

export default BrandWorldMegaMenu
